export default __webpack_public_path__ + "media/images/admin/plus-3c3eca9f024877cd8f00e77357b5a43c.svg";